import { InjectionToken } from '@angular/core';
import { SelectOption } from '@examdojo/util/select-option';
import { Observable } from 'rxjs';

export interface SmartLinkContext {
  url: string;
  newTab?: boolean;
}

export interface SmartLinkConfig {
  resolve: (identifier: string, context: SmartLinkContext) => void;
  selectOptions?: () => Observable<Array<SelectOption<string>>>;
}

export const SMART_LINK_CONFIG = new InjectionToken<SmartLinkConfig>('SMART_LINK_CONFIG');
